import axios from 'axios';
import http from "@/config/http";

export const login = async (data) => axios.post(`${process.env.REACT_APP_API_URL}v1/sessions/login`, data);

export const refresh = async (session_state) => http.post(`v1/sessions/refresh`,session_state);